import React from "react";
import SideCategory from "./SideCategory";
import PostSideBar from "./BlogsSideBar";
import SideSearchBar from "./SideSearchBar";
import SideTags from "./SideTags";

export default function SideBar() {
  return (
    <div className="col-lg-4 col-md-12 sidebar-right theiaStickySidebar">
      <div className="theiaStickySidebar">
        {/* <SideSearchBar /> */}
        <PostSideBar />
        {/* <SideCategory />
        <SideTags /> */}
      </div>
    </div>
  );
}
